module.exports = __webpack_public_path__ + "img/1_repair-car-sp.5a057e70.gif";